require('components/commons/wizardSuccess/wizardSuccess.scss');

const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const classnames = require('classnames');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTag } = require('commonsComponents/OKTag');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
// @ constants
const { recordProcess, PROC_BUY_GDI, PROC_END } = require('utilities/tagging');

class CmWizardSuccess extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(
            this,
        );
        this.handleMainButtonClick = this.handleMainButtonClick.bind(this);
        this.handleSecondaryButtonClick = this.handleSecondaryButtonClick.bind(
            this,
        );
    }

    componentDidMount() {
        const eventTag = this.props.eventTag;
        recordProcess(PROC_BUY_GDI, PROC_END, { processDetail: eventTag });
    }

    handleMainButtonClick() {
        const {
            history,
            onMainButtonClick,
            mainButton: { url },
        } = this.props;

        return onMainButtonClick
            ? onMainButtonClick()
            : url
            ? history.push(url)
            : history.goBack();
    }

    handleSecondaryButtonClick() {
        const {
            history,
            onSecondaryButtonClick,
            secondaryButton: { url, replaceUrl },
        } = this.props;
        if (onSecondaryButtonClick) {
            return onSecondaryButtonClick();
        }

        const shouldReplace = !!replaceUrl;

        if (url) {
            shouldReplace
                ? history.replace(url)
                : history.push(url);
        } else {
            history.goBack();
        }
    }

    render() {
        const {
            successMessage,
            successSubMessage,
            successTagLabelSubMessage,
            customClassName,
            children,
            mainButton,
            secondaryButton,
            successMessageChildren,
            secondaryButtonStyle,
        } = this.props;
        const classNames = classnames('wizard-success-step', customClassName);
        let myMainButton;
        let mySecondaryButton;
        let myButtons;
        let successTag;
        let subMessage;

        if (mainButton.label) {
            let isPrimaryButtonLoading = false;

            if (mainButton.loading) {
                isPrimaryButtonLoading = mainButton.loading;
            }

            myMainButton = (
                <div className="wizard-success-step__main-button">
                    <OKButton
                        id="lnk_wizardSuccessStep_mainButton"
                        modifier={
                            mainButton.modifier
                                ? mainButton.modifier
                                : 'additional-action-primary'
                        }
                        onClick={this.handleMainButtonClick}
                        loading={isPrimaryButtonLoading}
                    >
                        {mainButton.label}
                    </OKButton>
                </div>
            );
        }

        if (secondaryButton.label) {
            let secondaryButtonModifier = 'complementary-light';
            let isSecondaryButtonLoading = false;

            if (secondaryButtonStyle) {
                secondaryButtonModifier = secondaryButtonStyle;
            }

            if (secondaryButton.loading) {
                isSecondaryButtonLoading = secondaryButton.loading;
            }

            mySecondaryButton = (
                <div className="wizard-success-step__secondary-button">
                    <OKButton
                        id="lnk_wizardSuccessStep_secondaryButton"
                        modifier={secondaryButtonModifier}
                        onClick={this.handleSecondaryButtonClick}
                        loading={isSecondaryButtonLoading}
                    >
                        {secondaryButton.label}
                    </OKButton>
                </div>
            );
        }

        if (myMainButton || mySecondaryButton) {
            myButtons = (
                <div className="wizard-success-step__footer">
                    <div className="wizard-success-step__separator" />
                    <div className="wizard-success-step__foot-buttons">
                        {myMainButton} {mySecondaryButton}
                    </div>
                </div>
            );
        }

        if (!!successTagLabelSubMessage) {
            successTag = (
                <div className="wizard-success-step__success-tag-label-message">
                    <OKTag
                        content={successTagLabelSubMessage}
                        context="arrow"
                    />
                </div>
            );
        }

        if (successSubMessage || successTag) {
            subMessage = (
                <div className="wizard-success-step__success-sub-message">
                    {successSubMessage}
                    {successTag}
                </div>
            );
        }

        return (
            <div className={classNames}>
                <div className="wizard-success-step__highlight">
                    <i className="wizard-success-step__success-icon" />
                    <div className="wizard-success-step__messages">
                        <OKBoxTitle value={successMessage}>
                            {successMessageChildren}
                        </OKBoxTitle>
                        {subMessage}
                    </div>
                </div>
                <div className="wizard-success-step__content">{children}</div>
                {myButtons}
            </div>
        );
    }
}

CmWizardSuccess.defaultProps = {
    mainButton: {},
    secondaryButton: {},
    customClassName: '',
    successMessageChildren: null,
    secondaryButtonStyle: '',
};

CmWizardSuccess.propTypes = {
    eventTag: PropTypes.string,
    successMessage: PropTypes.string,
    successSubMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    successTagLabelSubMessage: PropTypes.string,
    customClassName: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    history: PropTypes.object.isRequired,
    mainButton: PropTypes.object,
    secondaryButton: PropTypes.object,
    secondaryButtonStyle: PropTypes.string,
    successMessageChildren: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    onMainButtonClick: PropTypes.func,
    onSecondaryButtonClick: PropTypes.func,
};

module.exports = withRouter(CmWizardSuccess);
